import { render, staticRenderFns } from "./CourseVideoCatalog.vue?vue&type=template&id=080fe09a&scoped=true&"
import script from "./CourseVideoCatalog.vue?vue&type=script&lang=js&"
export * from "./CourseVideoCatalog.vue?vue&type=script&lang=js&"
import style0 from "./CourseVideoCatalog.vue?vue&type=style&index=0&id=080fe09a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080fe09a",
  null
  
)

export default component.exports